import { EventBus } from "../../../eventbus";

export default {
  props: {
    file: Object,
  },
  data() {
    return {
      opperationPrefix: "file-editor-preview",
    };
  },

  methods: {
    resetChanges() {
      EventBus.$emit(`${this.opperationPrefix}--reset`);
    },
    downloadResult() {
      EventBus.$emit(`${this.opperationPrefix}--download`);
    },
    saveCopy() {
      EventBus.$emit(`${this.opperationPrefix}--save`);
    },
  },
};
